import { render, staticRenderFns } from "./UpdateCourse.vue?vue&type=template&id=54c7f062&scoped=true"
import script from "./UpdateCourse.vue?vue&type=script&lang=js"
export * from "./UpdateCourse.vue?vue&type=script&lang=js"
import style0 from "./UpdateCourse.vue?vue&type=style&index=0&id=54c7f062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7f062",
  null
  
)

export default component.exports